import { ArrowForwardIos, RocketLaunch, ExpandMore } from "@mui/icons-material";
import React, { memo, useState } from "react";
import { Handle, useReactFlow } from "react-flow-renderer";

const TRIGGERS = [
  {
    value: "none",
    label: "Nenhum gatilho",
    description: "Execute manualmente ou via campanha",
    color: "#9e9e9e",
    bg: "#f5f5f5",
    emoji: "⚙️",
  },
  {
    value: "lead_created",
    label: "Novo lead",
    description: "Dispara quando um novo contato inicia conversa",
    color: "#2e7d32",
    bg: "#e8f5e9",
    emoji: "🟢",
  },
  {
    value: "first_response",
    label: "Primeira resposta",
    description: "Dispara quando o lead responde pela primeira vez",
    color: "#1565c0",
    bg: "#e3f0fb",
    emoji: "💬",
  },
  {
    value: "message_received",
    label: "Mensagem recebida",
    description: "Dispara em toda mensagem recebida do contato",
    color: "#e65100",
    bg: "#fff3e0",
    emoji: "📩",
  },
];

export default memo(({ data, isConnectable, id }) => {
  const { setNodes } = useReactFlow();
  const [open, setOpen] = useState(false);

  const currentTrigger =
    TRIGGERS.find((t) => t.value === (data?.triggerType || "none")) ||
    TRIGGERS[0];

  const handleSelect = (value) => {
    setNodes((nds) =>
      nds.map((n) => {
        if (n.id === id) {
          return { ...n, data: { ...n.data, triggerType: value } };
        }
        return n;
      })
    );
    setOpen(false);
  };

  return (
    <div
      style={{
        backgroundColor: "#F9FDF9",
        padding: "8px",
        borderRadius: "8px",
        boxShadow: "rgba(0, 0, 0, 0.05) 0px 3px 5px",
        border: `1px solid ${currentTrigger.color}44`,
        minWidth: 200,
        position: "relative",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          marginBottom: 6,
        }}
      >
        <RocketLaunch
          sx={{ width: 16, height: 16, color: "#3aba38", marginTop: "2px" }}
        />
        <span style={{ color: "#232323", fontSize: 15, fontWeight: 600 }}>
          Início do fluxo
        </span>
      </div>

      {/* Trigger selector button */}
      <div
        onClick={() => setOpen((v) => !v)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: currentTrigger.bg,
          border: `1px solid ${currentTrigger.color}55`,
          borderRadius: 5,
          padding: "5px 8px",
          cursor: "pointer",
          userSelect: "none",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <span style={{ fontSize: 13 }}>{currentTrigger.emoji}</span>
          <span
            style={{
              color: currentTrigger.color,
              fontWeight: 700,
              fontSize: 11,
            }}
          >
            {currentTrigger.label}
          </span>
        </div>
        <ExpandMore
          sx={{
            width: 14,
            height: 14,
            color: currentTrigger.color,
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s",
          }}
        />
      </div>

      {/* Dropdown panel */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 9999,
            backgroundColor: "#fff",
            border: "1px solid #ddd",
            borderRadius: 6,
            boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
            marginTop: 4,
            overflow: "hidden",
          }}
        >
          {TRIGGERS.map((t) => (
            <div
              key={t.value}
              onClick={() => handleSelect(t.value)}
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 8,
                padding: "8px 10px",
                cursor: "pointer",
                backgroundColor:
                  currentTrigger.value === t.value ? t.bg : "transparent",
                borderBottom: "1px solid #f0f0f0",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = t.bg;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor =
                  currentTrigger.value === t.value ? t.bg : "transparent";
              }}
            >
              <span style={{ fontSize: 14, marginTop: 1 }}>{t.emoji}</span>
              <div>
                <div
                  style={{ fontWeight: 700, fontSize: 11, color: t.color }}
                >
                  {t.label}
                </div>
                <div style={{ fontSize: 10, color: "#777", marginTop: 1 }}>
                  {t.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#9a00ed",
          width: "18px",
          height: "18px",
          top: "50%",
          right: "-11px",
          cursor: "pointer",
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: "none",
          }}
        />
      </Handle>
    </div>
  );
});
